import React, { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AdminForm from "./AdminForm";
import AdminDetails from "./AdminDetails";
import OrderTable from "./OrderTable";
import { OrdersIcon, Filter, Calendar, Reset } from "../../../assets/icons";
import { SearchBar, Button } from "../../../UI";
import Container from "./styles";
import OrderView from "./OrderView"

const Orders = () => {
  const [search, setSearch] = useState("");
  const {pathname} = useLocation()
 
 

  return (
    <Container>
      <Routes>
        <Route path="OrderDetails" element={
          <>
            <header>
              <div style={{ display: "flex" }}>
                <h2 style={{ width: 150 }}>Orders details</h2>
                <OrdersIcon />
              </div>
            </header>
            <OrderView/>
          </>
        } />
        <Route
          path=":adminId/details"
          element={<AdminDetails />}
        />
        <Route path="rider" element={<AdminForm />} />
        <Route path="/" element={
          <>
            <header>
              <div className="top--row">
                <h2>All Orders</h2>
                <OrdersIcon />
              </div>
              <SearchBar
                placeholder="Search by Order No"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </header>
            <div className="admin--content__container">
              <OrderTable search={search} />
            </div>
          </>
        } />
      </Routes>
    </Container>
  );
};

export default Orders;
